import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  theme => ({
    styedPaper: {
      display: "flex",
      flexFlow: "column",
      justifyContent: "space-between",
      alignItems: "center"
    },
    paperContents: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 20,
      fontWeight: 600,
      padding: "14px 18px",
      wordBreak: "break-all",
      width: "100%"
    },
    deleteIcon: {
      "&:hover": {
        backgroundColor: "transparent",
        color: theme.palette.primary.main
      }
    },
    spinnerContainer: {
      margin: 12
    },
    footerButtonsContainer: {
      "& > button > span": {
        color: "#9098A1"
      },
      "& > button:last-child": {
        "& > span": {
          color: "#FFF"
        },
        backgroundColor: "#1848FE"
      },
      "& > span": {
        marginTop: 8
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
      gap: "8px"
    }
  }),
  { name: "DisplayFileComponent" }
);

export default useStyles;
